import { cn } from 'src/lib/utils';

export const Step = ({ isActive = false, isCompleted = false }) => {
  return (
    <div
      className={cn(
        'relative flex-1 h-1 bg-gray-200 after:bg-mint after:absolute after:top-0 after:left-0 after:h-full after:w-full after:transition-transform after:duration-300 after:origin-left overflow-hidden after:translate-x-[-100%] after:scale-0',
        isActive && 'h-1.5 translate-y-[-1px] after:translate-x-0 after:scale-100',
        isCompleted && 'bg-foreground',
      )}
    />
  );
};

type Props = {
  currentStep: number;
  completedStep: number;
  totalSteps: number;
};

const SoftwareOnboardingProgress = ({ currentStep, completedStep, totalSteps }: Props) => {
  return (
    <div className="flex grow-1 gap-4">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <Step
          key={index}
          isActive={index + 1 === currentStep}
          isCompleted={index + 1 <= completedStep && index + 1 !== currentStep}
        />
      ))}
    </div>
  );
};

export { SoftwareOnboardingProgress };
